import { ContainerModule } from 'inversify'
import { InviteActionHandler } from './actions'

const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(InviteActionHandler).to(InviteActionHandler).inSingletonScope()
    })
]

export { DI_MODULES }
